/* eslint-disable @typescript-eslint/no-explicit-any */
import { sendCustomEvent } from './send-custom-event';

export interface OddsClickCustomEventProps {
  betLocation?: string;
  betName: string;
  betOdds: Record<string, any>[];
  bookieCode: string;
  event: string;
  eventName?: string;
  marketName?: string;
  oddsFormat?: string;
  pageTitle?: string;
  subeventDisplayName?: string;
  subeventName?: string;
}

export function sendOddsClickCustomEvent({ ...props }: OddsClickCustomEventProps): void {
  sendCustomEvent({
    ...props,
    eventLabel: 'odds-button-clicked',
    pageUrl: window ? window.location.href : '',
    timeStamp: new Date().toLocaleString(),
  });
}
